import type {
  PortfolioManagementportfoliosv1BatchGetAccountsRequest,
  PortfolioManagementportfoliosv1BatchGetAccountsResponse,
  V1BatchUpdateAccountsRequest,
  V1BatchUpdateAccountsResponse,
  V1BulkCreateAccountsRequest,
  V1BulkCreateAccountsResponse,
  V1ResolveAccountSensitiveDataRequest,
  V1ResolveAccountSensitiveDataResponse,
  V1SendAccountRequest,
  V1SendAccountResponse,
} from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/account_api';
import type { PortfolioManagementportfoliosv1Mandate } from '@blk/aladdin-graph-client-axios-internal/wealth/portfolio_management/portfolios/v1/mandate_api';
import { awPortfolioManagementApi } from './Base';

const ACCOUNTS_PATH = 'portfolios/v1/accounts';

export function postSendAccounts(request: V1SendAccountRequest) {
  const path = `${ACCOUNTS_PATH}:send`;
  return awPortfolioManagementApi.post<V1SendAccountResponse>(path, request);
}

export function postBatchGetAccounts(request: PortfolioManagementportfoliosv1BatchGetAccountsRequest) {
  const path = `${ACCOUNTS_PATH}:batchGet`;
  return awPortfolioManagementApi.post<PortfolioManagementportfoliosv1BatchGetAccountsResponse>(path, request);
}

export function bulkCreateAccounts(request: V1BulkCreateAccountsRequest) {
  const path = `${ACCOUNTS_PATH}:bulkCreate`;
  return awPortfolioManagementApi.post<V1BulkCreateAccountsResponse>(path, request);
}

export function updateMandate(mandate: PortfolioManagementportfoliosv1Mandate) {
  const accountId = mandate.parentReference?.account?.accountId;
  const path = `${ACCOUNTS_PATH}/${accountId}/mandate`;
  return awPortfolioManagementApi.put<PortfolioManagementportfoliosv1Mandate>(path, mandate);
}

export function resolveAccountSensitiveData(payload: V1ResolveAccountSensitiveDataRequest) {
  const path = `${ACCOUNTS_PATH}:resolveSensitiveData`;
  return awPortfolioManagementApi.post<V1ResolveAccountSensitiveDataResponse>(path, payload);
}

export function batchUpdateAccounts(request: V1BatchUpdateAccountsRequest) {
  const path = `${ACCOUNTS_PATH}:batchUpdate`;
  return awPortfolioManagementApi.post<V1BatchUpdateAccountsResponse>(path, request);
}
